(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["resenas-fotos-luz"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hpk-resenas')) {
    customElements.define('hpk-resenas', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-rv-track]');
        if (!this.track) return;
        this.mq = window.matchMedia('(max-width: 749px)');
        this.onMq = this.setup.bind(this);
        this.onScroll = this.handleScroll.bind(this);
        if (this.mq.addEventListener) this.mq.addEventListener('change', this.onMq);
        else this.mq.addListener(this.onMq);
        this.setup();
      }

      disconnectedCallback() {
        if (!this.mq) return;
        if (this.mq.removeEventListener) this.mq.removeEventListener('change', this.onMq);
        else this.mq.removeListener(this.onMq);
        this.teardown();
      }

      realSlides() {
        return Array.prototype.slice.call(this.track.querySelectorAll('[data-rv-slide]:not([data-rv-clone])'));
      }

      setup() {
        this.teardown();
        if (!this.mq.matches) return;
        var slides = this.realSlides();
        if (slides.length < 2) return;

        var k = Math.min(2, slides.length);
        var track = this.track;
        slides.slice(-k).reverse().forEach(function (slide) {
          var c = slide.cloneNode(true);
          c.setAttribute('data-rv-clone', '');
          c.setAttribute('aria-hidden', 'true');
          c.removeAttribute('id');
          track.insertBefore(c, track.firstChild);
        });
        slides.slice(0, k).forEach(function (slide) {
          var c = slide.cloneNode(true);
          c.setAttribute('data-rv-clone', '');
          c.setAttribute('aria-hidden', 'true');
          c.removeAttribute('id');
          track.appendChild(c);
        });

        this.active = true;
        var self = this;
        requestAnimationFrame(function () { self.jumpTo(slides[0]); });

        if ('onscrollend' in window) {
          track.addEventListener('scrollend', this.onScroll);
        } else {
          track.addEventListener('scroll', this.onScroll, { passive: true });
        }
      }

      teardown() {
        if (!this.track) return;
        this.track.removeEventListener('scrollend', this.onScroll);
        this.track.removeEventListener('scroll', this.onScroll);
        clearTimeout(this.scrollTimer);
        this.track.querySelectorAll('[data-rv-clone]').forEach(function (c) { c.remove(); });
        this.active = false;
      }

      centerOf(slide) {
        return slide.offsetLeft + slide.offsetWidth / 2 - this.track.clientWidth / 2;
      }

      jumpTo(slide) {
        var track = this.track;
        track.style.scrollSnapType = 'none';
        track.style.scrollBehavior = 'auto';
        track.scrollLeft = this.centerOf(slide);
        void track.offsetWidth;
        requestAnimationFrame(function () {
          track.style.scrollSnapType = '';
          track.style.scrollBehavior = '';
        });
      }

      handleScroll(e) {
        var self = this;
        if (e.type === 'scroll') {
          clearTimeout(this.scrollTimer);
          this.scrollTimer = setTimeout(function () { self.checkLoop(); }, 140);
          return;
        }
        this.checkLoop();
      }

      checkLoop() {
        if (!this.active) return;
        var track = this.track;
        var center = track.scrollLeft + track.clientWidth / 2;
        var all = track.querySelectorAll('[data-rv-slide]');
        var closest = null;
        var best = Infinity;
        for (var i = 0; i < all.length; i++) {
          var mid = all[i].offsetLeft + all[i].offsetWidth / 2;
          var d = Math.abs(mid - center);
          if (d < best) { best = d; closest = all[i]; }
        }
        if (!closest || !closest.hasAttribute('data-rv-clone')) return;
        var real = track.querySelector('[data-rv-slide]:not([data-rv-clone])[data-index="' + closest.dataset.index + '"]');
        if (real) this.jumpTo(real);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
